import { createSelector } from 'reselect';

import { selectSearchResults } from './trips';

function _getAllFeatures(trips) {
    if (!trips) {
        return [];
    }

    const allFeatures = new Set();

    trips.forEach((trip) => {
        const legs = trip.isRouted
            ? trip.tripLegs.filtered
            : [trip];

        legs.forEach((leg) => {
            leg.features.forEach((feature) => allFeatures.add(feature));
        });
    });

    return [...allFeatures];
}

const selectFeaturesTripData = createSelector(
    selectSearchResults,
    _getAllFeatures,
);

export {
    selectFeaturesTripData,
};
